import { useCallback, useMemo } from 'react';
import useKeyboardShortcuts, { ShortcutDef } from './useKeyboardShortcuts';
import useVoyagerStore from '../stores/useVoyagerStore';
import { startNewQuestion } from '../shell/chatSidebarState';
import { openSearchPalette } from '../shell/searchPaletteState';

export default function useAppShortcuts() {
  const executeQuery = useVoyagerStore((s) => s.executeQuery);

  const handleRunQuery = useCallback(() => {
    executeQuery();
  }, [executeQuery]);

  const handleFocusSearch = useCallback(() => {
    // ⌘K is the search palette whose first row asks (#1514, owner, 2026-10-22), Query Builder included
    openSearchPalette();
  }, []);

  const handleToggleSql = useCallback(() => {
    document.dispatchEvent(new CustomEvent('dx:toggle-sql'));
  }, []);

  const shortcuts: ShortcutDef[] = useMemo(() => [
    { key: 'Enter', meta: true, shift: true, handler: handleRunQuery },
    { key: 'k', meta: true, handler: handleFocusSearch },
    { key: '/', meta: true, handler: handleToggleSql },
    // ⌘⇧O is New chat
    { key: 'o', meta: true, shift: true, handler: startNewQuestion },
  ], [handleRunQuery, handleFocusSearch, handleToggleSql]);

  useKeyboardShortcuts(shortcuts);
}
